<template>
    <ContentComponent />
</template>

<script>
    import ContentComponent from '@/components/AboutPage/ContentComponent'

    export default {
        name: "About",
        components: {
            ContentComponent
        }
    }
</script>

<style lang="sass" scoped>
</style>
